import Axios from '@/packages/axios/Axios';

export default {
  data() {
    return {
      companyData: {},
    };
  },
  methods: {
    loadCompanyData() {
      return new Promise((resolve, reject) => {
        Axios.get(`/v1/companies/${this.$route.params.companyId}`)
          .then((response) => {
            this.companyData = response.data;
            resolve();
          })
          .catch((e) => {
            if (e.response) {
              switch (e.response.status) {
                case 401:
                  this.$router.push('/error/401');
                  break;
                case 403:
                  this.$router.push('/error/403');
                  break;
                case 404:
                  this.$router.push('/error/404');
                  break;
                default:
                  this.$router.push('/error/unknown');
              }
            } else {
              reject(e);
            }
          });
      });
    },
  },
};
